import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import {select, Store} from "@ngrx/store";
import { EMPTY, map, mergeMap, withLatestFrom } from "rxjs";
import { AppService } from "../app.service";
import { DashboardService } from "../services/dashboard.service";
import { dashboardFetchAPISuccess, invokeDashboardAPI } from "./dashboard.action";
import { DashboardSelector } from "./dashboard.selector";

@Injectable()
export class DashboardEffect {

    constructor(
        private actions$: Actions,
        private dashoardService: DashboardService,
        private store: Store,
        private appService: AppService
    ) {}

    loadAllData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(invokeDashboardAPI),
            withLatestFrom(this.store.pipe(select(DashboardSelector))),
            mergeMap(([, dashboardformStore]) => {
                // if(dashboardformStore.length > 0) {
                //     return EMPTY;
                // }
                let user = JSON.parse(localStorage.getItem("user")!)

                if(user) {

                    let obj = {
                        'idUser': user.id,
                        'key': 'ALL',
                        'year' : new Date().getFullYear(),
                        'years' : this.appService.getLastTenYears()
                    }
                    return this.dashoardService
                        .index(obj)
                        .pipe(map((data) => dashboardFetchAPISuccess({allData: data})));

                } else {

                    return EMPTY;
                    
                }
                
            })
        )
  );

}
